export const defData = {
  subpatterns: [
    {
      selected: 'V',
      subpattern: 'a/e/i/o/u'
    },
    {
      selected: 'C',
      subpattern: 'p/t/k/b/d/g/s/m/n/l/r'
    },
    {
      selected: 'N',
      subpattern: 'm/n'
    }
  ],
  pattern: 'V/CV/CVN/CVCV/CVCVN',
  words: 100,
  newline: false,
  filterdupes: false
}

export const vars = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
]
